
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 95 66","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.222 0C9.51 0 0 9.495 0 21.29c0 11.094 8.509 20.09 19.32 21.09-2.202 3.997-6.206 8.295-13.013 12.393-1.902 1.1-3.104 3.099-3.104 5.198 0 4.298 4.405 7.296 8.41 5.497 11.611-5.197 30.931-17.891 30.931-44.178C42.544 9.495 33.034 0 21.222 0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M73.877 0C62.065 0 52.555 9.495 52.555 21.29c0 11.094 8.509 20.09 19.32 21.09-2.202 3.997-6.207 8.295-13.014 12.393-1.902 1.1-3.103 3.099-3.103 5.198 0 4.298 4.405 7.296 8.409 5.497 11.512-5.197 30.832-17.791 30.832-44.178C95.099 9.495 85.589 0 73.877 0z","fill":"currentColor"}})])
          )
        }
      }
    